import { render, staticRenderFns } from "./ProductQuickView.vue?vue&type=template&id=19c4d6da&scoped=true&"
import script from "./ProductQuickView.vue?vue&type=script&lang=js&"
export * from "./ProductQuickView.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuickView.vue?vue&type=style&index=0&id=19c4d6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4d6da",
  null
  
)

export default component.exports